import { resolveApiBaseUrl } from "@/config/api-base-url";

/**
 * C1: the one way to turn an API path into a URL. Always resolves against the API base
 * (`VITE_API_BASE_URL`, `/api` in dev), so it works with the API on another origin today and
 * same-origin behind the frontend's `/api` proxy later — a config change, not a code change.
 *
 * Accepts `/v1/...`, `v1/...` and legacy `/api/v1/...` (the `/api` prefix is folded into the
 * base, OPS-1/OPS-3). Absolute http(s) URLs are returned unchanged.
 */
export function apiUrl(path: string, base: string = resolveApiBaseUrl()): string {
  if (/^https?:\/\//i.test(path)) return path;
  let rest = path.startsWith("/") ? path : `/${path}`;
  if (rest === "/api" || rest.startsWith("/api/") || rest.startsWith("/api?")) {
    rest = rest.slice("/api".length) || "/";
  }
  return `${base}${rest}`;
}
